import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
export type AccordionItem = {
  title: string;
  body: string;
  lead?: string;
};
type AccordionProps = {
  items: AccordionItem[];
  idPrefix: string;
};
export function Accordion({
  items,
  idPrefix
}: AccordionProps) {
  const [open, setOpen] = useState<number | null>(null);
  const reduce = useReducedMotion();
  return <div className="border-t border-gold/30" data-id="element-1" data-mp="2n24ffxn9d7jj">
      {items.map((item, i) => {
      const isOpen = open === i;
      const panelId = `${idPrefix}-panel-${i}`;
      const buttonId = `${idPrefix}-button-${i}`;
      return <div key={item.title} className="border-b border-gold/30" data-id="element-2" data-mp="2s3blns9r5yo3" data-mpi={i}>
            <h3 data-id="element-3" data-mp="2s0xsxq2joyjp">
              <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-4" data-mp="11qmh3q80ul2j">
                <span className="flex items-baseline gap-4" data-id="element-5" data-mp="3q29xt5v5zmy6">
                  {item.lead && <span className="w-5 shrink-0 font-serif text-[1.6rem] leading-none text-gold" data-id="element-6" data-mp="3q0grxssdl6r8">{item.lead}</span>}
                  <span className="font-serif text-[1.4rem] leading-snug text-ivory md:text-2xl" data-id="element-7" data-mp="3ngrhg1l3qjd">{item.title}</span>
                </span>
                <PlusIcon aria-hidden="true" strokeWidth={1.25} className={`h-6 w-6 shrink-0 text-gold transition-transform duration-200 ease-out-strong ${isOpen ? 'rotate-45' : ''}`} data-id="element-8" data-mp="7mh9iwc8mp5b" />
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-9" data-mp="2egl054ej7v6n">
              {isOpen && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={reduce ? false : {
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={reduce ? {
            opacity: 0
          } : {
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-10" data-mp="2jew8tbt3bzna">
                  <p className={`pb-5 pr-10 text-base leading-relaxed text-ivory/85 ${item.lead ? 'pl-9' : ''}`} data-id="element-11" data-mp="2ub7z32l3i02q">
                    {item.body}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}